export const getFirstChar = string => string ? string[0] : ''
